import { Button, Col, DatePicker, Divider, Form, Input, InputNumber, Row, Select, Tag } from 'antd';
import React, { useEffect, useState } from 'react';
import PageHeaderComponent from '../../../helpers/components/page_header.component';
import { CloseOutlined } from '@ant-design/icons';
import parkService from '../../../services/config/park.service';

const CreatePeriodPassLayout = ({ form, }) => {
    const [select, setSelect] = useState({
        parks : [],
    })

    const tagRender = ({ label, value, closable, onClose }) => {
        const onPreventMouseDown = (event) => {
          event.preventDefault();
          event.stopPropagation();
        };
        return (
          <Tag
            color={'var(--secondary-button-color)'}
            onMouseDown={onPreventMouseDown}
            closable={closable}
            onClose={onClose}
            style={{ color : 'var(--secondary-text-color)'}}
            closeIcon={<CloseOutlined style={{color:'var(--secondary-text-color)'}} />}
          >
            {label}
          </Tag>
        );
    };

    const initializeSelection = async () => {
        const getParkResponse = await parkService?.getParkByAuth();
        const { parks } = getParkResponse;
        setSelect(select => ({...select, parks : parks}));
    }

    useEffect(() => {
        initializeSelection();
    }, [])

    return (
        <>
            <div className='mobile-padding-12'>
                <Divider />
                <div>
                    <PageHeaderComponent title={<span style={{fontSize:16,}}>Pass Generation</span>} textAlign={'start'} />
                </div>
                <div style={{marginTop:12,}}>
                    <Row gutter={[20, 0]}>
                        <Col xs={24} sm={12} span={12}>
                            <Form.Item name={'prefix'} label={'Prefix'} style={{textAlign:'start',}}>
                                <Input placeholder='e.g. Singkang' />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={12} span={12}>
                            <Form.Item name={'quantity'} label={'Quantity'} style={{textAlign:'start',}}>
                                <InputNumber min={1} style={{width:'100%'}} placeholder='e.g. 500' />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={12} span={12}>
                            <Form.Item name={'from_date'} label={'From Date'} style={{textAlign:'start',}}>
                                <DatePicker style={{width:'100%'}} />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={12} span={12}>
                            <Form.Item name={'end_date'} label={'End Date'} style={{textAlign:'start',}}>
                                <DatePicker style={{width:'100%'}} />
                            </Form.Item>
                        </Col>
                    </Row>
                </div>

                <Divider />
                <div>
                    <PageHeaderComponent title={<span style={{fontSize:16,}}>Park Access</span>} textAlign={'start'} />
                </div>
                <div style={{marginTop:12,}}>
                    <Row gutter={[20, 0]}>
                        <Col xs={24} sm={12} span={12}>
                            <Form.Item name="parks" label="Parks" style={{textAlign:'start',}}>
                                <Select
                                tagRender={tagRender}
                                mode='multiple'
                                options={select?.parks?.map((park) => {
                                    const { name, park_id } = park;
                                    return { label: name, value: park_id };
                                })}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                </div>
            </div>
        </>
    );
}

export default CreatePeriodPassLayout;
